<template>
  <div>
    <div class="d-flex flex-column sm-gap">
      <div class="spo-card rounded" v-for="(inscription, index_inscription) in bookingStore.inscriptions"
        :key="index_inscription">
        <div class="px-2 py-1 font-weight-bold bg-spo-blue-grey">{{ get_nom_coureur(inscription.coureur,
          index_inscription) }} {{
            inscription.get_equipe_name() != '' ? ' - Equipe ' + inscription.get_equipe_name() : '' }}</div>
        <CartCoureurItem class="px-2 py-1" :item="inscription"></CartCoureurItem>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useBookingStore } from "@/stores/bookingStore";
import CartCoureurItem from "@/components/App/Shopping_Cart/Cart_Coureur_Item.vue";
export default {
  components: { CartCoureurItem },
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useBookingStore),
  },
  methods: {
    get_nom_coureur(coureur, index) {
      let nom = coureur.get_nom();
      if (nom.length > 1) {
        return nom;
      }
      return "Coureur n°" + parseInt(index + 1);
    },
  },

};
</script>

<style lang="scss" scoped></style>